import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function Nav({ externalVotingUrl, onScrollToForms, onScrollToPitches }) {
  return (
    <nav data-testid="main-nav" className="bg-white border-b border-emerald-200 sticky top-0 z-30">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
          <div className="h-10 w-10 rounded-full bg-white border border-emerald-300 flex items-center justify-center overflow-hidden">
            <img src="/bs-logo-square.png" alt="Business Showers" className="w-full h-full object-contain p-0.5" />
          </div>
          <div className="leading-tight">
            <div className="font-[Cormorant_Garamond] text-lg text-emerald-950">Business Showers</div>
            <div className="font-[Outfit] text-[10px] uppercase tracking-[0.25em] text-emerald-800/70">2026 Campaign</div>
          </div>
        </Link>
        <div className="hidden md:flex items-center gap-2">
          <button onClick={onScrollToPitches} data-testid="nav-pitches" className="font-[Outfit] text-sm text-emerald-900 hover:text-emerald-700 px-3 py-2">Pitch Schedule</button>
          <Link to="/replays" className="font-[Outfit] text-sm text-emerald-900 hover:text-emerald-700 px-3 py-2" data-testid="nav-replays">Replays</Link>
          <a href="#judges" className="font-[Outfit] text-sm text-emerald-900 hover:text-emerald-700 px-3 py-2" data-testid="nav-judges">Judges</a>
          <Link to="/sponsor" className="font-[Outfit] text-sm text-emerald-900 hover:text-emerald-700 px-3 py-2" data-testid="nav-sponsor">Sponsor</Link>
          <Link to="/volunteer" className="font-[Outfit] text-sm text-emerald-900 hover:text-emerald-700 px-3 py-2" data-testid="nav-volunteer">Volunteer</Link>
          <Link to="/tickets" className="font-[Outfit] text-sm text-emerald-900 hover:text-emerald-700 px-3 py-2" data-testid="nav-tickets">Tickets</Link>
          <button onClick={onScrollToForms} data-testid="nav-getinvolved" className="font-[Outfit] text-sm text-emerald-900 hover:text-emerald-700 px-3 py-2">Get Involved</button>
        </div>
        <div className="flex items-center gap-2">
          <Button asChild data-testid="nav-vote-btn" className="rounded-full bg-rose-500 hover:bg-rose-600 text-white font-[Outfit]">
            <a href={externalVotingUrl} target="_blank" rel="noreferrer">Vote · $2</a>
          </Button>
        </div>
      </div>
    </nav>
  );
}
